import { Form } from 'mobx-react-form';
import dvr from 'mobx-react-form/lib/validators/DVR';
import validatorjs from 'validatorjs';

class ChannelInviteForm extends Form {
  constructor(data, options) {
    super(data, options);
  }

  options() {
    return {
      validateOnInit: false,
      validateOnChange: true,
      validateOnBlur: false,
    };
  }

  /*
    Below we are returning a `plugins` object using the `validatorjs` package
    to enable `DVR` functionalities (Declarative Validation Rules).
  */
  plugins() {
    return {
      dvr: dvr({ package: validatorjs }),
    };
  }

  /*
    Return the `fields` as a collection into the `setup()` method
    with a `rules` property for the validation.
  */
  setup() {
    return {
      fields: [
        { name: 'invitee', rules: 'min:0', value: [] },
        { name: 'kicked', rules: 'min:0', value: [] },
        { name: 'openChat', value: true },
      ],
    };
  }
}

export default ChannelInviteForm;
